import ShopSelector from './src/main';

/* istanbul ignore next */
ShopSelector.install = function(Vue) {
  Vue.component(ShopSelector.name, ShopSelector);
};

export default ShopSelector;
